import React, { lazy, Suspense } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import "../Tools.css";
import "../css/Articles.css";

//const ArticleOfMessages = lazy(() => import("../component/ArticleOfMessages"));
const ArticleOfBaby = lazy(() => import("../component/ArticleOfBaby"));
const ArticleOfPregnancy = lazy(() =>
  import("../component/ArticleOfPregnancy")
);
const ArticleOfOvulation = lazy(() =>
  import("../component/ArticleOfOvulation")
);
const ArticleOfPregnancyAdvices = lazy(() =>
  import("../component/ArticleOfPregnancyAdvices")
);
const ArticleOfKid = lazy(() => import("../component/ArticleOfKid"));

const LazyImage = lazy(() => import("../component/LazyImage"));
function OnlyArticlePage(props) {
  const location = useLocation();
  const [metaDesc, setMetaDesc] = React.useState();
  const [header, setHeader] = React.useState();
  const [showBabyArticles, setShowBabyArticles] = React.useState(false);
  const [showPregnancyArticles, setShowPregnancyArticles] =
    React.useState(false);
  const [showOvulationArticles, setShowOvulationArticles] =
    React.useState(false);
  const [showAdviceArticles, setShowAdviceArticles] = React.useState(false);
  const [showKidArticles, setShowKidArticles] = React.useState(false);
  const [itemImage, setItemImage] = React.useState(null);
  const [locationPathname, setLocationPathname] = React.useState("");

  const { loc } = props;
  const renderLoader = () => (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        height: "50vmax",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h1
        className="font-merriweather"
        style={{ color: "#ffffff", fontSize: 18 }}
      >
        Momercy: Annelerin ve Bebeklerin Güvenilir Rehberi.
      </h1>
      <h2
        className="font-merriweather"
        style={{ color: "#ffffff", fontSize: 18 }}
      >
        Haftalık hamilelik takvimini önümüzdeki dokuz ay için nihai rehberiniz
        olarak kabul edin.
      </h2>
      <h3
        className="font-merriweather"
        style={{ color: "#ffffff", fontSize: 18 }}
      >
        Haftalık Hamilelik Bebek Gelişim Takibi,Persentil Hesaplama Uygulaması
      </h3>
    </div>
  );

  React.useEffect(() => {
    try {
      window.scrollTo(0, 0);
      const pathname = location.pathname;
      setLocationPathname(pathname);
      const arr = pathname.split("/");
      let tempDesc = "";
      if (arr[1] === "makaleler") {
        const ids = arr[arr.length - 1].split("-");
        let article_array = [];
        if (arr[2] === "dogum-bebek-gelisimi-takibi") {
          setShowBabyArticles(true);
          return;
        } else if (arr[2] === "hamilelik-planlama-ovulasyon") {
          setShowOvulationArticles(true);
          return;
        } else if (arr[2] === "hafta-hamile-gebelik-takibi") {
          setShowPregnancyArticles(true);
          return;
        } else if (arr[2] === "anne-cocuk-bebek-urun-onerileri") {
          setShowAdviceArticles(true);
          return;
        } else if (arr[2] === "anne-cocuk-gelisimi-takibi") {
          setShowKidArticles(true);
          return;
        }
        tempDesc =
          article_array[ids[1]].values[ids[2]].content[0].tag === "p"
            ? article_array[ids[1]].values[ids[2]].content[0].text
            : article_array[ids[1]].values[ids[2]].content[1].text;
        if (
          article_array[ids[1]].values[ids[2]].products !== undefined &&
          article_array[ids[1]].values[ids[2]].products !== null &&
          article_array[ids[1]].values[ids[2]].products.length > 0
        ) {
          article_array[ids[1]].values[ids[2]].source =
            article_array[ids[1]].values[ids[2]].products[0].image;
        }
        setHeader(article_array[ids[1]].values[ids[2]].header);
      } else if (arr[2] === "articles") {
        const ids = arr[arr.length - 1].split("-");
        let article_array = [];
        if (arr[3] === "birth-baby-development-tracking") {
          setShowBabyArticles(true);
          return;
        } else if (arr[3] === "pregnancy-planning-ovulation") {
          setShowOvulationArticles(true);
          return;
        } else if (arr[3] === "week-pregnant-tracking") {
          setShowPregnancyArticles(true);
          return;
        } else if (arr[3] === "mother-child-baby-product-recommendations") {
          setShowAdviceArticles(true);
          return;
        } else if (arr[3] === "anne-cocuk-gelisimi-takibi") {
          setShowKidArticles(true);
          return;
        }
        tempDesc =
          article_array[ids[1]].values[ids[2]].content[0].tag === "p"
            ? article_array[ids[1]].values[ids[2]].content[0].text
            : article_array[ids[1]].values[ids[2]].content[1].text;
        if (
          article_array[ids[1]].values[ids[2]].products !== undefined &&
          article_array[ids[1]].values[ids[2]].products !== null &&
          article_array[ids[1]].values[ids[2]].products.length > 0
        ) {
          article_array[ids[1]].values[ids[2]].source =
            article_array[ids[1]].values[ids[2]].products[0].image;
        }
        setHeader(article_array[ids[1]].values[ids[2]].header);
      }
      if (tempDesc !== null && tempDesc !== "") {
        if (tempDesc.length > 158) {
          tempDesc = tempDesc.substring(0, 155) + "...";
        }
        setMetaDesc(tempDesc);
      }
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  return (
    <div className={"mainRoot"}>
      <Helmet>
        {metaDesc && (
          <meta
            name="description"
            content={metaDesc}
            data-react-helmet="true"
          />
        )}
        {header && <title>{header}</title>}
        <meta
          property="og:site_name"
          content={
            loc === "en"
              ? "Pregnancy Tracking and Baby Development"
              : "Hamilelik Takibi ve Bebek Gelişimi"
          }
        />
        <meta
          property="og:url"
          content={`https://www.momercy.com/${location.pathname}`}
        />
        <meta property="og:locale" content={loc === "en" ? "en_EN" : "tr_TR"} />
        <meta
          property="og:title"
          content={
            loc === "en"
              ? "Pregnancy Tracking and Baby Development"
              : "Hamilelik Takibi ve Bebek Gelişimi"
          }
        />
        <meta
          property="og:description"
          content={
            loc === "en"
              ? "Pregnancy and pregnancy follow-up, nutrition during pregnancy, baby girl names, ovulation menstrual calendar, baby development application for mothers."
              : "Hamilelik ve gebelik sürecinde takip, hamilelikte beslenme, kız erkek bebek isimleri, yumurtlama regl takvimi, anneler için bebek gelişimi uygulaması."
          }
        />
        <meta
          name="twitter:title"
          content={
            loc === "en"
              ? "Pregnancy Tracking and Baby Development"
              : "Hamilelik Takibi ve Bebek Gelişimi"
          }
        />
        <meta
          name="twitter:description"
          content={
            loc === "en"
              ? "Pregnancy and pregnancy follow-up, nutrition during pregnancy, baby girl names, ovulation menstrual calendar, baby development application for mothers."
              : "Hamilelik ve gebelik sürecinde takip, hamilelikte beslenme, kız erkek bebek isimleri, yumurtlama regl takvimi, anneler için bebek gelişimi uygulaması."
          }
        />
        <link
          rel="canonical"
          href={`https://www.momercy.com${location.pathname}`}
        />
      </Helmet>
      <div className={props.isMobile ? `` : `App-Root gradient-background`}>
        <Grid
          display="flex"
          container
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} sm={6}>
            <Paper
              style={{
                padding: props.isMobile ? 15 : 30,
                textAlign: "center",
                minHeight: 150,
              }}
            >
              <h1 className="article-head padding-bottom-40">{header}</h1>
              {itemImage && (
                <LazyImage
                  head={header}
                  image={itemImage}
                  className="Article-Head_Image"
                  isMobile={props.isMobile}
                />
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
      <div className="general-area" style={{ marginTop: 0, paddingBottom: 0 }}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid container alignItems="center" justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Paper
                style={{
                  padding: props.isMobile ? 15 : 30,
                  textAlign: "left",
                  minHeight: 150,
                }}
              >
                <article>
                  {showBabyArticles && (
                    <Suspense fallback={renderLoader()}>
                      <ArticleOfBaby
                        loc={loc}
                        itemImage={setItemImage}
                        pathname={locationPathname}
                        header={setHeader}
                        tempDesc={setMetaDesc}
                      />
                    </Suspense>
                  )}
                  {showPregnancyArticles && (
                    <Suspense fallback={renderLoader()}>
                      <ArticleOfPregnancy
                        loc={loc}
                        itemImage={setItemImage}
                        pathname={locationPathname}
                        header={setHeader}
                        tempDesc={setMetaDesc}
                      />
                    </Suspense>
                  )}
                  {showOvulationArticles && (
                    <Suspense fallback={renderLoader()}>
                      <ArticleOfOvulation
                        loc={loc}
                        itemImage={setItemImage}
                        pathname={locationPathname}
                        header={setHeader}
                        tempDesc={setMetaDesc}
                      />
                    </Suspense>
                  )}
                  {showAdviceArticles && (
                    <Suspense fallback={renderLoader()}>
                      <ArticleOfPregnancyAdvices
                        loc={loc}
                        itemImage={setItemImage}
                        pathname={locationPathname}
                        header={setHeader}
                        tempDesc={setMetaDesc}
                      />
                    </Suspense>
                  )}
                  {showKidArticles && (
                    <Suspense fallback={renderLoader()}>
                      <ArticleOfKid
                        itemImage={setItemImage}
                        pathname={locationPathname}
                        header={setHeader}
                        tempDesc={setMetaDesc}
                      />
                    </Suspense>
                  )}
                </article>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default OnlyArticlePage;
